import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { validateEmail } from '../../utils/validation';
import AuthLayout from '../../components/Layout/Auth/AuthLayout';
import { CONSTS } from '../../const';
import ForgotPasswordCard from './ForgotPasswordCard';
import ForgotPasswordContent from './ForgotPasswordContent';
import { getErrMsgFromResp, handleErrorToast } from '../../utils/errorHandler';
import { graphqlClient } from '../../utils/client/graphql';
import { FORGOT_PASSWORD_MUTATION } from '../../graphql/queries';

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleForgotPassword = async () => {
    // Validate email
    setLoading(true);
    const emailValidation = validateEmail(email);
    if (!emailValidation.isValid) {
      setError(emailValidation.error);
      return;
    }
    try {
      const response = await graphqlClient.request(FORGOT_PASSWORD_MUTATION, {
        email: email,
      });

      const forgot = response?.forgotPassword;
      const status = forgot?.status;
      const data = forgot?.data;
      if (status === CONSTS.VER || status === CONSTS.ERR) {
        setError(forgot?.message || forgot?.errorCode);
        return;
      }
      navigate('/forgot-password', {
        state: {
          screen: 'otp',
          email: email,
          otpKey: data?.otpKey,
          resendTime: data?.resendReadyTime,
        },
      });
    } catch (err) {
      setError(getErrMsgFromResp(err));
      console.error('Forgot password error:', err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    handleErrorToast(error);
    setTimeout(() => {
      setError('');
    }, 500);
  }, [error]);

  return (
    <AuthLayout leftContent={<ForgotPasswordContent />}>
      <ForgotPasswordCard
        email={email}
        setEmail={setEmail}
        // error={error}
        handleForgotPassword={handleForgotPassword}
        loading={loading}
      />
    </AuthLayout>
  );
};

export default ForgotPassword;
